import {Component, default as React} from "react";
import {Footer} from "../components/Footer";
import {Header} from "../components/Header";
import {ToastContainer} from "react-toastify";
import {RatesCommissionContent} from "../components/rates/RatesCommissionContent";
import {RatesDiffContent} from "../components/rates/RatesDiffContent";

export class RatesPage extends Component {
    render = () => (
        <>
            <Header isDark={false}/>
            <ToastContainer autoClose={6000}/>
            <RatesDiffContent />
            <RatesCommissionContent />
            <Footer isDark={false}/>
        </>
    );
}